/**
 * Which card slots are worth rendering.
 *
 * `reader_detail` returns all 78 ReaderDeck rows whether or not the Mystic has
 * painted them. (`service_reader.get_major_cards`, which feeds the community
 * hero, does exclude art-less rows — reader_detail is the one endpoint that
 * doesn't.) Each unpainted row still painted a bordered, empty box in the deck
 * grid, so a half-painted deck read as a broken page rather than as a deck in
 * progress.
 *
 * Nothing is invented to fill the hole and no placeholder stands in its place:
 * a slot with no art is simply not shown.
 */

/** Does this card actually have art to show? */
export function hasArt(card) {
  if (!card) return false
  // reader_detail's deck rows carry `image_url`; the community hero's
  // major_cards and the Just Arrived filmstrip carry `image`.
  const src = card.image_url || card.image || ''
  return typeof src === 'string' && src.trim() !== ''
}

/** The subset of a card list that can be rendered as cards. */
export function cardsWithArt(cards) {
  return (Array.isArray(cards) ? cards : []).filter(hasArt)
}
